export const COMPANY_LEGAL = {
  name: 'Metal Covering S.r.l.',
  vat: '02932950799',
  address: 'Via Campania snc, 89900 Vibo Marina (VV)',
  sdi: 'M5UXCR1',
  email: 'info@metalcovering.org',
  phone: '+39 348 3719995',
  privacyEmail: 'info@metalcoveringsrl.com',
  dpo: 'Gianluca Bagnato',
  dpoEmail: 'g.bagnato@metalcovering.org',
  consentVersion: '1.0',
  lastUpdate: 'giugno 2026',
};

export const COOKIE_KEY = 'mc_cookie_consent';

export function getCookieConsent() {
  try { return JSON.parse(localStorage.getItem(COOKIE_KEY)); } catch { return null; }
}

export function openCookiePreferences() {
  window.dispatchEvent(new CustomEvent('open-cookie-prefs'));
}

// Consent Mode v2: aggiorna le autorizzazioni in base alla scelta cookie
export function applyConsentToGtag(v) {
  try {
    if (typeof window === 'undefined' || !window.gtag) return;
    window.gtag('consent', 'update', {
      ad_storage: v && v.marketing ? 'granted' : 'denied',
      ad_user_data: v && v.marketing ? 'granted' : 'denied',
      ad_personalization: v && v.marketing ? 'granted' : 'denied',
      analytics_storage: v && v.analytics ? 'granted' : 'denied',
    });
  } catch (e) {}
}

// Google Ads: Conversion Label (inserire qui quando disponibile da Google Ads)
export const ADS_ID = 'AW-18400902627';
export const ADS_CONVERSION_LABEL = 'pF7qCK659OQcEOP7ncZE';

// Evento conversione candidatura completata (una sola volta, alla conferma finale)
export function fireApplicationCompleted() {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'application_completed' });
    if (window.gtag && ADS_CONVERSION_LABEL) {
      window.gtag('event', 'conversion', {
        send_to: ADS_ID + '/' + ADS_CONVERSION_LABEL,
        value: 1.0,
        currency: 'EUR',
      });
    }
  } catch (e) {}
}
